import { ListResponse } from '../../goodstack'

import { InfiniteQueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { SearchFundraiserQuery, SearchFundraiserResponse } from './searchFundraisers.types'

export const searchFundraisers: InfiniteQueryFn<
  [string, SearchFundraiserQuery],
  string,
  ListResponse<SearchFundraiserResponse>
> = async (client, [_, { query = '', pageSize = 25, targetCountries, includeUnlisted }], cursor) =>
  (
    await (cursor
      ? client.get<ListResponse<SearchFundraiserResponse>>(cursor, {
          withCredentials: true
        })
      : client.get<ListResponse<SearchFundraiserResponse>>(`v1/search-fundraisers`, {
          params: {
            pageSize,
            ...(query && { query }),
            ...(targetCountries && { targetCountries }),
            ...(includeUnlisted && { includeUnlisted })
          },
          withCredentials: true
        }))
  ).data
